<div class="banner-edit-container">
  <div class="dialog-header">
    <h2>{{ isNew ? 'Add New Banner' : 'Edit Banner' }}</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="bannerForm" class="banner-form">

      <!-- Image Upload Section -->
      <div class="image-section">
        <div class="image-preview" [class.no-image]="!previewUrl">
          <img *ngIf="previewUrl" [src]="previewUrl" alt="Banner preview" class="preview-image">
          <div *ngIf="!previewUrl" class="no-image-placeholder">
            <mat-icon>image</mat-icon>
            <p>No image selected</p>
          </div>
        </div>

        <div class="upload-section">
          <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" hidden>
          <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            {{ previewUrl ? 'Change Image' : 'Upload Image' }}
          </button>
          <p class="upload-hint">Recommended: 2045 x 983 px, JPG or PNG, max 2MB</p>
        </div>
      </div>

      <!-- Date Fields -->
      <div class="form-fields">
        <div class="date-row">
          <mat-form-field class="date-field">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" placeholder="Select from date"
              [min]="minFromDate" [max]="maxDate" [matDatepickerFilter]="fromDateFilter">
            <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
            <mat-error *ngIf="bannerForm.get('fromDate')?.invalid && bannerForm.get('fromDate')?.touched">
              {{ getErrorMessage('fromDate') }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="date-field">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toPicker" formControlName="toDate" placeholder="Select to date"
              [min]="minToDate" [max]="maxDate" [matDatepickerFilter]="toDateFilter"
              [disabled]="!bannerForm.get('fromDate')?.value">
            <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
            <mat-error *ngIf="bannerForm.get('toDate')?.invalid && bannerForm.get('toDate')?.touched">
              {{ getErrorMessage('toDate') }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- 🔧 ADD DATE HINTS -->
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()" type="button">
      Cancel
    </button>

  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!isFormValid" type="button">
      {{ isNew ? 'Add Banner' : 'Save Changes' }}
    </button>
  </mat-dialog-actions>
</div>
